import { useQuery } from "react-query";
import { QueryKeys } from "../../network/queryKeys";
import ms from "ms";
import { CitiesAPI } from "@/api/cities";
import { tInternalCity } from "@/types";

export const useHighlightedCitiesQuery = () => {
  return useQuery<tInternalCity[]>(
    QueryKeys.highlightedCities,
    () => CitiesAPI.getHighlighted(),
    {
      staleTime: ms("30 minutes"),
      cacheTime: Infinity,
    }
  );
};
